import React from 'react';
import {
    SP_SKIP, extractResponseData, SmartStyles, SmartHeader, SmartSection, NoRecordsCard, RawResponseButton
} from './_SmartFieldRenderer';

const GROUPS = {
    identity:     { title: 'IDENTITY',           icon: 'pi-id-card',     keys: ['id_number', 'nuid', 'registration_number', 'registration_year', 'doctor_name', 'nurse_name', 'name', 'full_name'] },
    professional: { title: 'PROFESSIONAL',       icon: 'pi-briefcase',   keys: ['qualification', 'specialization', 'category', 'designation', 'council', 'state_medical_council', 'university'] },
    status:       { title: 'STATUS',             icon: 'pi-verified',    keys: ['status', 'registration_status', 'verification_status', 'valid_from', 'valid_upto', 'expiry_date', 'registration_date'] },
    contact:      { title: 'CONTACT & ADDRESS',  icon: 'pi-map-marker',  keys: ['address', 'city', 'state', 'pin_code', 'email', 'mobile', 'phone'] },
};

const HIGHLIGHT = ['id_number', 'nuid', 'registration_number'];

const NurseDoctorOutputComponent = ({ reportData, hideCredits, isSharedView, title = 'Verification Report', icon = 'pi-user' }) => {
    const shouldHideCredits = hideCredits || isSharedView;
    const { responseData, remainingBalance, errorMsg, hasRealData } = extractResponseData(reportData);

    if (!reportData) return <NoRecordsCard subtitle="No data available" />;
    if (!responseData || !hasRealData) {
        return <NoRecordsCard errorMsg={errorMsg} subtitle="No records found. Please verify the input and try again." />;
    }

    const d = responseData;
    const grouped = {};
    for (const [groupName, group] of Object.entries(GROUPS)) {
        const picked = {};
        group.keys.forEach(k => { if (k in d && d[k] !== null && d[k] !== undefined && d[k] !== '') picked[k] = d[k]; });
        if (Object.keys(picked).length > 0) grouped[groupName] = picked;
    }
    const knownKeys = new Set(Object.values(GROUPS).flatMap(g => g.keys));
    const leftover = {};
    for (const [k, v] of Object.entries(d)) {
        if (SP_SKIP.has(k) || knownKeys.has(k)) continue;
        if (v === null || v === undefined || v === '') continue;
        leftover[k] = v;
    }

    return (
        <div>
            <SmartStyles />
            <SmartHeader title={title} icon={icon} remainingBalance={remainingBalance} shouldHideCredits={shouldHideCredits} />
            <div className="horizontal-report-card">
                {Object.entries(GROUPS).map(([groupName, meta]) => (
                    grouped[groupName]
                        ? <SmartSection key={groupName} title={meta.title} icon={meta.icon} data={grouped[groupName]} highlightKeys={HIGHLIGHT} />
                        : null
                ))}
                {Object.keys(leftover).length > 0 && (
                    <SmartSection title="OTHER DETAILS" icon="pi-info-circle" data={leftover} />
                )}
                <RawResponseButton data={d} />
            </div>
        </div>
    );
};

export default NurseDoctorOutputComponent;
